var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isClinro } from '@/config';
import { UMOTIF_API } from '@/routes';
import api from './instance';
const { DATA_CAPTURE } = UMOTIF_API;
class CaptureService {
    getQuestionnaire(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { questionnaire_id, submitted_for } = payload;
            const { data } = yield api.get(DATA_CAPTURE.GET_QUESTIONNAIRE, {
                params: Object.assign(Object.assign({}, (isClinro && { capro_for: submitted_for })), { questionnaire_id })
            });
            return data;
        });
    }
    getPartialSubmission(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.get(DATA_CAPTURE.GET_PARTIAL(payload));
            return data;
        });
    }
    cachedQueryMany(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(DATA_CAPTURE.CACHED_QUERY_MANY, payload);
            return data.results;
        });
    }
    cachedQuerySingle(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(DATA_CAPTURE.CACHED_QUERY_SINGLE, payload);
            return data.result;
        });
    }
    latestSourcedData(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { answers, now_override, query } = payload;
            const { data } = yield api.post(DATA_CAPTURE.GET_LATEST_SOURCED_DATA, Object.assign(Object.assign({ answers }, (now_override && { now_override })), { query }));
            return data.answers;
        });
    }
    overlap(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { group_by_key, now_override } = payload;
            const { data } = yield api.post(DATA_CAPTURE.POST_OVERLAP, Object.assign({ group_by_key }, (now_override && { now_override })));
            return data.answers;
        });
    }
    startUpload(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(DATA_CAPTURE.POST_START_UPLOAD, payload);
            return data;
        });
    }
    submitQuestionnaire(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(DATA_CAPTURE.POST_SUBMISSIONS, payload);
            return data;
        });
    }
    submitPartialQuestionnaire(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(DATA_CAPTURE.POST_PARTIALS, payload);
            return data;
        });
    }
    eventSubmissionCheck(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { status } = yield api.get(DATA_CAPTURE.EVENT_SUBMISSION_CHECK(payload));
            return status;
        });
    }
}
export default new CaptureService();
